import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class FoodService {
    constructor(private apiHttp: ApiHttp) {
    }

    public addRestaurant(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodRestaurant/AddRestaurant', data, messageService);
    }

    public updateRestaurant(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodRestaurant/UpdateRestaurant', data, messageService);
    }

    public getRestaurantById(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodRestaurant/GetRestaurantById', data, messageService);
    }

    public getRestaurants(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminFoodRestaurant/GetRestaurantList', data, messageService);
    }

    public getRestaurantsForCombo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminFoodRestaurant/GetRestaurantListForCombo', data, messageService);
    }

    public addCategory(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/AddCategory', data, messageService);
    }

    public updateCategory(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/UpdateCategory', data, messageService);
    }

    public getCategoryById(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/GetCategoryById', data, messageService);
    }

    public getAdminCategories(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminFoodProduct/GetCategoryList', data, messageService);
    }

    public getCategories(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/GetCategoryList', data, messageService);
    }

    public addModifier(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/AddModifier', data, messageService);
    }

    public updateModifier(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/UpdateModifier', data, messageService);
    }

    public getModifierById(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/GetModifierById', data, messageService);
    }

    public getAdminModifiers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminFoodProduct/GetModifierList', data, messageService);
    }

    public getModifiers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/GetModifierList', data, messageService);
    }

    public addModifierGroup(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/AddModifierGroup', data, messageService);
    }

    public updateModifierGroup(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/UpdateModifierGroup', data, messageService);
    }

    public getModifierGroupById(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/GetModifierGroupById', data, messageService);
    }

    public getAdminModifierGroups(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminFoodProduct/GetModifierGroupList', data, messageService);
    }

    public getModifierGroups(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/GetModifierGroupList', data, messageService);
    }

    public addProduct(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/AddProduct', data, messageService);
    }

    public updateProduct(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/UpdateProduct', data, messageService);
    }

    public getProductById(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/FoodProduct/GetProductById', data, messageService);
    }

    public getProducts(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminFoodProduct/GetProductList', data, messageService);
    }
}
